import ReactDOMServer from 'react-dom/server';
import React from 'react';
import moment from 'moment';
import 'moment-timezone';
import Tooltip from '@material-ui/core/Tooltip';

export class HTMLNotification {

  constructor() {
    this.html = '';
  }

  //Le notifica al Doctor sobre la Transcripcion
  notificationTranscription(nombre_usuario, nombre_paciente, id_admision, fecha_notificacion) {
    let mensaje = ' ha realizado una Transcripcion en la Admision ';
    let transcriptor = nombre_usuario;
    const html = (<div>
      <div className="topbar__collapse-img-wrap">
        <img className="topbar__collapse-img" src={`${process.env.PUBLIC_URL}/img/man-1280.png`} alt="" />
      </div>
      <p className="topbar__collapse-message">
        <span className="topbar__collapse-name">{transcriptor}</span>
        {mensaje}<span className="topbar__collapse-name">{id_admision}</span>
      </p>
      <p className="topbar__collapse-date">
        <span>
          {
            moment(fecha_notificacion).format("YYYY/MM/DD") == moment().tz("America/Bogota").format("YYYY/MM/DD") ?
              moment(fecha_notificacion).format("HH:mm:ss") : moment(fecha_notificacion).format("YYYY/MM/DD HH:mm:ss")
          }
        </span>
      </p>
    </div>);
    let htmlString = ReactDOMServer.renderToStaticMarkup(html);
    return htmlString;
  }

  //Le notifica al Transcriptor la respuesta del Doctor
  notificationTranscriptionResponseDoctor(fecha_notificacion, msjAceptacion, msjContinuo, id_admision) {
    const html = (<div>
      <div className="topbar__collapse-img-wrap">
        <img className="topbar__collapse-img" src={`${process.env.PUBLIC_URL}/img/man-1280.png`} alt="" />
      </div>
      <p className="topbar__collapse-message">
        <span className="topbar__collapse-name">{msjAceptacion}</span>
        {msjContinuo} <span className="topbar__collapse-name">{id_admision}</span>
      </p>
      <p className="topbar__collapse-date">
        <span>
          {
            moment(fecha_notificacion).format("YYYY/MM/DD") == moment().tz("America/Bogota").format("YYYY/MM/DD") ?
              moment(fecha_notificacion).format("HH:mm:ss") : moment(fecha_notificacion).format("YYYY/MM/DD HH:mm:ss")
          }
        </span>
      </p>
    </div>);
    let htmlString = ReactDOMServer.renderToStaticMarkup(html);
    return htmlString;
  }

  //Le notifica al Doctor que se ha Subido una imagen diagnostica
  notificationDiagnosticImages(fecha_notificacion, notificacion, paciente) {

    let remitente = notificacion.remitente;
    let admision = notificacion.id_admision;


    const html = (<div>
      <div className="topbar__collapse-img-wrap">
        <img className="topbar__collapse-img" src={`${process.env.PUBLIC_URL}/img/man-1280.png`} alt="" />
      </div>
      <p className="topbar__collapse-message">
        <span className="topbar__collapse-name">{remitente}</span>
        {' ha subido una Imagen Diagnostica en la Admision '} <span className="topbar__collapse-name">{admision}</span>
      </p>
      <p className="topbar__collapse-date">
        <span>
          {
            moment(fecha_notificacion).format("YYYY/MM/DD") == moment().tz("America/Bogota").format("YYYY/MM/DD") ?
              moment(fecha_notificacion).format("HH:mm:ss") : moment(fecha_notificacion).format("YYYY/MM/DD HH:mm:ss")
          }
        </span>
      </p>
    </div>);
    let htmlString = ReactDOMServer.renderToStaticMarkup(html);
    return htmlString;
  }

  //Notificacion al Transcriptor cuando el Medico graba el audio
  notificationAudioDoctorToTranscriptor(fecha_notificacion, notificacion) {
    let remitente = notificacion.remitente;
    let admision = notificacion.id_admision;
    const html = (<div>
      <div className="topbar__collapse-img-wrap">
        <img className="topbar__collapse-img" src={`${process.env.PUBLIC_URL}/img/man-1280.png`} alt="" />
      </div>
      <p className="topbar__collapse-message">
        <span className="topbar__collapse-name">{remitente}</span>
        {' ha realizado una Grabación de la admisión '} <span className="topbar__collapse-name">{admision}</span>
        {' , por favor revisar para la Transcripción'}
      </p>
      <p className="topbar__collapse-date">
        <span>
          {
            moment(fecha_notificacion).format("YYYY/MM/DD") == moment().tz("America/Bogota").format("YYYY/MM/DD") ?
              moment(fecha_notificacion).format("HH:mm:ss") : moment(fecha_notificacion).format("YYYY/MM/DD HH:mm:ss")
          }
        </span>
      </p>
    </div>);
    let htmlString = ReactDOMServer.renderToStaticMarkup(html);
    return htmlString;
  }

}